export type TSelectContentBlockControl = {
  scrollIntoView: () => void
}

export enum SelectLTPResult {
  SKIP = 'skip',
  CONTINUE = 'continue',
  FAST_SUCCESS = 'fast-payment-success',
}

export type TNextPageFn = (result: SelectLTPResult) => void
